import { ApiResult } from '../../apiClient/apiResult';
import { axiosClient } from '../../apiClient/axiosClient';
import { SupportServiceCategory } from '../../types/supportServiceCategory';

type SupportServiceCategoryIndexResponse = SupportServiceCategory[];
type SupportServiceCategoryUpdateRequest = {
  name?: string;
  viewable?: number;
  order?: number;
};

type SupportServiceCategoryUpdateOrderRequest = {
  orders: {
    id: number;
    order: number;
  }[];
};

export const supportServiceCategoryApiClient = {
  index: async (): Promise<ApiResult<SupportServiceCategoryIndexResponse>> => {
    return await axiosClient.get('/tenant/support-service-categories');
  },
  update: async (
    id: number,
    params: SupportServiceCategoryUpdateRequest,
  ): Promise<ApiResult<SupportServiceCategory>> => {
    return await axiosClient.put(`/tenant/support-service-categories/${id}`, params);
  },
  updateOrder: async (params: SupportServiceCategoryUpdateOrderRequest): Promise<ApiResult> => {
    return await axiosClient.put('/tenant/support-service-categories/order', params);
  },
};
